import { getRepubMetaFromRepub } from '@cx-web/utils';
import type { MetaFunction } from '@remix-run/node';

import { getCanonicalURL } from '~/utils/getCanonicalURL';

import { type loader } from './loader';

export const meta: MetaFunction<never, { [routeId: string]: typeof loader }> = ({ location, matches }) => {
  const layoutMatch = matches.find(match => /layout$/.test(match.id));
  const repub = layoutMatch?.data?.repub;

  if (!repub) {
    throw new Error('Repub data is missing from layout match');
  }

  const { repubIs } = getRepubMetaFromRepub(repub);
  const matchCentreName = repubIs.OC ? 'Match Centre' : 'Match Center';
  const data = matches.find(match => /match-centre$/.test(match.id))?.data;

  return [
    { title: `${matchCentreName} | Oddschecker+` },
    { name: 'description', content: `${matchCentreName} Schedule | Oddschecker+` },
    { tagName: 'link', rel: 'canonical', href: getCanonicalURL(data?.url.toString(), location.pathname) },
  ];
};
